import { Component, OnInit } from '@angular/core';
import { qmsService } from '../qms/qms.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class UserNotificationsComponent implements OnInit{


  constructor(private qmsService : qmsService){

  }

  ngOnInit(): void {
    this.qmsService.activityId = null;
  }

}
